import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { RadiusParam } from '#/modules/search/helpers/radius';
import { searchGetQueryParamsFromFiltersByName } from '#/modules/search/routing/helpers/searchGetQueryParamsFromFiltersByName';
import { searchEventsPathReference } from '#/modules/search/routing/search.paths';
import type { SearchEventFiltersByName } from '#/modules/search/types/FiltersByName/SearchEventFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';

import { searchEventsPathByLocale } from './searchEvents.paths';

type Args = {
  locale: I18nLocale;
  q?: string;
  radius?: RadiusParam;
  filtersByName?: Omit<SearchEventFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
};

export function searchGetEventsPath({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchEventsPathReference
    .with(queryParams)
    .replace('/-lang/-segment', searchEventsPathByLocale[locale]);
}
